import { PictureUploader } from "@/components/PictureUploader";
import { UniversalRoutes } from "@/routers/routes";

export const PortraitUpload: React.FC = () => (
  <PictureUploader
    title="Upload Your Portrait"
    endpoint="/trainer/profile/portrait"
    returnToRoute={UniversalRoutes.PROFILE.HOME}
  />
);
